<template>


    <v-card flat tile class="selling-points-card" style="padding: 150px 0;">
        <v-container class="my-5">
            <v-row>
                <v-col cols="12" sm="4" v-for="sellingPoint in sellingPoints" :key="sellingPoint.img">
                    <v-card flat tile class="pa-3">
                        <div class="text-center">
                            <img :src="require(`../../assets/illustrations/${sellingPoint.img}.png`)" alt="">
                        </div>
                        <div class="text-h4 text-center d-flex justify-center selling-point-header" >
                            {{ $t(sellingPoint.headerKey) }}
                        </div>
                        <div class="pt-8" style="font-size: 18px;">
                            {{ $t(sellingPoint.textKey) }}
                        </div>
                    </v-card>
                </v-col>


            </v-row>
        </v-container>


    </v-card>


</template>

<script>
    const sellingPointConfigs = [
        {
            img: "globe",
            headerKey: "homepage.sellingPoint1Header",
            textKey: "homepage.sellingPoint1Text",
        },
        {
            img: "clipboard",
            headerKey: "homepage.sellingPoint2Header",
            textKey: "homepage.sellingPoint2Text",
        },
        {
            img: "hourglass",
            headerKey: "homepage.sellingPoint3Header",
            textKey: "homepage.sellingPoint3Text",
        },
    ]


    export default {
        name: "UserLogos",
        data() {
            return {
                sellingPoints: sellingPointConfigs,
            }
        }
    }
</script>

<style lang="scss">


    .selling-points-card {
        img {
            height: 160px;
        }
    }

</style>
